import { SUB_TABS as OPS_SUB_TABS } from "../../../ops/constants/orderSubTabs";

/** The ops console's own "Ready to Dispatch" status set, reused verbatim. */
const OPS_READY_STATUSES = OPS_SUB_TABS.find((tab) => tab.id === "ready_dispatch").statuses;

// The prototype's four Orders tabs, mapped onto real `enum_userOrders_status` values.
//
// The prototype maps each tab to exactly ONE status (`ORDER_STATUS_MAP`: to_process ->
// ORDER_PENDING, drx_created -> USER_DRX_PENDING, ready_dispatch ->
// SHIPPED_MEDICINES_PACKED, completed -> DELIVERED). That works against 14 hand-written
// fixtures and not against real data, where an order sitting in OCS_PROCESSING or
// CONSENT_PENDING belongs in "To Be Processed" but matches none of those four values and
// would vanish from every tab.
//
// So each tab here is a SET of statuses, the same shape the ops console's sub-tabs use.
// A tab that silently hides orders is worse than no tab.
export const PHARMACY_TABS = [
    {
        id: "to_process",
        label: "To Be Processed",
        // Confirmed but not yet through pre-sorting: awaiting consent, payment or OCS.
        //
        // ORDER_CONFIRMED belongs here and now works. It was omitted at first because it
        // was missing from ALLOWED_status in pillup-api's classes/UserOrder/Constants.js,
        // and that guard rejects the ENTIRE query when one filter value is unlisted —
        // so including it emptied the whole tab with "Invalid parameter" rather than
        // adding a row. Fixed backend-side, decoupling the filter allow-list from
        // FUTURE_ORDER_STATUSES so reorder eligibility was not changed along with it.
        statuses: [
            "ORDER_PENDING",
            "ORDER_ACTIVE",
            "ORDER_CONFIRMED",
            "CONSENT_PENDING",
            "CONSENT_GRANTED",
            "PAYMENT_PENDING",
            "PAYMENT_CONFIRMED",
            // Follows PAYMENT_CONFIRMED directly when the whole order is in stock.
            // Requires pillup-api with the ORDER_PROCURED migration -- an unknown
            // value rejects this whole tab's query.
            "ORDER_PROCURED",
            "OCS_PENDING",
            "OCS_PROCESSING",
            "CALL_PENDING",
        ],
    },
    {
        id: "drx_created",
        label: "DRX Created",
        // The digital-Rx loop with the patient, including the two LSQ-webhook statuses
        // added to the enum in Aug 2026.
        statuses: [
            "ORDER_DRX_CREATED",
            "ORDER_DRX_SENT",
            "USER_DRX_PENDING",
            "USER_DRX_ACCEPTED",
            "USER_DRX_REJECTED",
        ],
    },
    {
        id: "ready_dispatch",
        label: "Ready to Dispatch",
        // Packed through in-transit. Reused from the ops sub-tabs rather than re-listed
        // so the two consoles cannot drift on what "ready to dispatch" means.
        statuses: OPS_READY_STATUSES,
    },
    {
        // No status filter — everything, including delivered and cancelled.
        id: "all",
        label: "All Orders",
        statuses: [],
    },
];

export const DEFAULT_PHARMACY_TAB = "to_process";
